// components/StatusCell.js
import {Tooltip} from "antd";
import {memo} from "react";

export const StatusCell = memo(({enable}) => (
    <Tooltip title={enable === 1 ? 'Активен' : 'Неактивен'}>
        <span style={{
            display: 'inline-block',
            width: '8px',
            height: '8px',
            borderRadius: '4px',
            backgroundColor: enable === 1 ? '#52c41a' : '#d9d9d9',
            cursor: 'help'
        }}/>
    </Tooltip>
));

StatusCell.displayName = 'StatusCell';